import axios from '../utils/axios/axiosPse'

const createTransactionAsync = (request) => {
        return new Promise((resolve, reject) => {
            axios.post('', request)
                 .then((response) => {
                    resolve(response);
                 })
                 .catch((error) => {
                    reject(error);
                 });                
            });
    };

const getTransactionAsync = (paymentId) => {
    return new Promise((resolve, reject) => {
        axios.get('?PaymentID=' + paymentId)
             .then((response) => {
                resolve(response);
             })
             .catch((error) => {
                reject(error);
             });   
    });
};

export {
    createTransactionAsync,
    getTransactionAsync
}